import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-labelledby="garantia-titulo" className="w-full bg-white py-14 sm:py-16" data-id="element-109" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-3xl px-5" data-id="element-110" data-mp="223y26yk3prfw">
        <div className="flex flex-col items-center gap-5 rounded-3xl border-2 border-dashed border-gold bg-cream p-7 text-center sm:p-10" data-id="element-111" data-mp="222mz70yhcnpu">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-gold" data-id="element-112" data-mp="19ehe2d3ikwph">
            <ShieldCheckIcon className="h-8 w-8 text-navy-deep" aria-hidden="true" data-id="element-113" data-mp="14fxuukgb1z0t" />
          </span>

          <h2 id="garantia-titulo" className="font-display text-2xl font-extrabold uppercase tracking-wide text-navy sm:text-3xl" data-id="element-114" data-mp="1j4ai8t1bu9jp">
            Garantía 7 días — sin preguntas
          </h2>

          <p className="text-base leading-relaxed text-navy/80" data-id="element-115" data-mp="qn7vlebrmxlr">
            Abrís los tomos. Los usás con tu hijo/a o en el aula. Si en 7 días no es lo
            que esperabas:{' '}
            <strong className="font-extrabold text-navy" data-id="element-116" data-mp="p0b89y58teh0">devolución del 100%</strong>, sin
            formularios, sin drama.
          </p>

          <p className="rounded-full bg-navy px-4 py-2 text-sm font-bold text-white" data-id="element-117" data-mp="twrwstgctuum">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </div>
    </section>;
}